module.exports = __webpack_public_path__ + "static/img/industrial-storage-container_256.d35511d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industrial-storage-container_256.png
// module id = rGbk
// module chunks = 0